import React from 'react'

const PhotoDownloader = () => {
  return (
    <div>PhotoDownlaoder</div>
  )
}

export default PhotoDownloader